import { dangerColor, successColor, toqueColor, white } from '../theme/colors'

export const handleColorState = (state: string): string => {
  const colorMap: { [key: string]: string } = {
    Activo: successColor,
    Vacío: toqueColor,
    Seleccione: white,
  }

  return colorMap[state] ?? dangerColor
}
